"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _ActivityFeed = _interopRequireDefault(require("./ActivityFeed"));
var _ClickDropDown = _interopRequireDefault(require("./ClickDropDown"));
var _constants = require("./constants");
var _Functionality = require("./Functionality.style");
var _LiveChat = _interopRequireDefault(require("./LiveChat"));
var _Logout = _interopRequireDefault(require("./Logout/Logout.render"));
var _logger = _interopRequireDefault(require("../../../../../utils/logger"));
var _ChangePassword = _interopRequireDefault(require("../../../../ChangePassword"));
var _DisabledLink = _interopRequireDefault(require("../../../../DisabledLink"));
var _Link = _interopRequireDefault(require("../../../../Link"));
/* eslint-disable max-lines */

const NavItemFunctionality = _ref => {
  let {
    id,
    children,
    type,
    icon,
    link,
    newTab,
    onClick,
    onNavItemSelected,
    onNavItemDeselected,
    selected,
    setRef,
    navItemRef,
    headerLink,
    noRightMargin,
    menuItemId,
    setClickedItem,
    currentSection,
    isPrimaryNav,
    openChangePasswordModal
  } = _ref;
  const navItemType = _constants.navItemToFunctionalityMapping[type];
  let functionalityComponent;
  switch (navItemType) {
    case _constants.navItemFunctionalityType.SALE_FORCE:
      {
        functionalityComponent = /*#__PURE__*/React.createElement(React.Fragment, null, children);
        break;
      }
    case _constants.navItemFunctionalityType.CHANGE_PASSWORD:
      {
        const linkElement = /*#__PURE__*/React.createElement(_ChangePassword.default, {
          openModal: openChangePasswordModal
          // @ts-ignore
          ,
          onFocus: onNavItemSelected
          // @ts-ignore
          ,
          onBlur: onNavItemDeselected
        }, children);
        functionalityComponent = linkElement;
        break;
      }
    case _constants.navItemFunctionalityType.LINK:
      {
        if (!link) {
          functionalityComponent = null;
          break;
        }
        const linkElement = /*#__PURE__*/React.createElement(_Link.default, {
          to: link
          // @ts-ignore
          ,
          target: newTab ? '_blank' : null
          // @ts-ignore
          ,
          onFocus: onNavItemSelected
          // @ts-ignore
          ,
          onBlur: onNavItemDeselected
        }, children);
        functionalityComponent = headerLink ?
        /*#__PURE__*/
        // @ts-ignore
        React.createElement(_Functionality.NavItemLinkWrapper, {
          isCurrentSection: currentSection,
          isPrimaryNav: isPrimaryNav,
          isAskICIS: window.location.href.includes('askicis'),
          selected: selected,
          "data-test-id": id,
          onMouseEnter: onNavItemSelected,
          onMouseLeave: onNavItemDeselected,
          noRightMargin: noRightMargin,
          isSelectable: true
        }, linkElement) : linkElement;
        break;
      }
    case _constants.navItemFunctionalityType.DISABLED_LINK:
      functionalityComponent = /*#__PURE__*/React.createElement(_DisabledLink.default, null, children);
      break;
    case _constants.navItemFunctionalityType.LOGOUT:
      functionalityComponent = /*#__PURE__*/React.createElement(_Logout.default, null, children);
      break;
    case _constants.navItemFunctionalityType.CLICK_DROP_DOWN:
      functionalityComponent =
      /*#__PURE__*/
      // @ts-ignore
      React.createElement(_ClickDropDown.default, {
        key: icon,
        icon: icon,
        menuItemId: menuItemId,
        setClickedItem: setClickedItem,
        setRef: setRef,
        navItemRef: navItemRef,
        selected: selected,
        onMouseEnter: onNavItemSelected,
        onMouseLeave: onNavItemDeselected,
        id: id
      }, children);
      break;
    case _constants.navItemFunctionalityType.DROP_DOWN:
      functionalityComponent =
      /*#__PURE__*/
      // @ts-ignore
      React.createElement(_Functionality.NavItemLinkWrapper, {
        isCurrentSection: currentSection,
        isPrimaryNav: isPrimaryNav,
        "data-test-id": id,
        onMouseEnter: onNavItemSelected,
        onMouseLeave: onNavItemDeselected,
        selected: selected,
        isSelectable: true,
        ref: setRef ? setRef() : null,
        isDropDown: true,
        noRightMargin: noRightMargin
      }, children);
      break;
    case _constants.navItemFunctionalityType.LIVE_CHAT:
      // @ts-ignore
      functionalityComponent = /*#__PURE__*/React.createElement(_LiveChat.default, {
        onClick: onClick
      }, children);
      break;
    case _constants.navItemFunctionalityType.COMPONENT:
      functionalityComponent = /*#__PURE__*/React.createElement(React.Fragment, null, children);
      break;
    case _constants.navItemFunctionalityType.ACTIVITY_FEED:
      functionalityComponent = /*#__PURE__*/React.createElement(_ActivityFeed.default, {
        setClickedItem: setClickedItem,
        menuItemId: menuItemId,
        selected: selected,
        setRef: setRef,
        navItemRef: navItemRef
      }, children);
      break;
    default:
      functionalityComponent = null;
      _logger.default.warn("Unknown nav item type ".concat(type));
  }
  return functionalityComponent;
};
var _default = exports.default = NavItemFunctionality;